import { useEffect, useMemo, useState } from 'react';
import CardCommon from '@/pages/opinion/components/CardCommon';
import React from 'react';
import { Row } from 'tea-component';
import TaptapLogo from '@/pages/opinion/assets/svg/TapTapLogo.svg';
import ScoreTrendBox from './ScoreTrendBox';
import { useResize } from '@/pages/opinion/hooks/useResize';
import { useIntl } from 'umi';
import useGetStoreTimeline from '../../hooks/useGetStoreTimeline';

export default function ScoreTrends({ filter, gameInfo, channel }: any) {
  const [showMoreScoreTrend, setShowMoreScoreTrend] = useState(false);
  const showMoreTrend = () => {
    setShowMoreScoreTrend(!showMoreScoreTrend);
  };
  const { formatMessage } = useIntl();

  const { colSpan, refCallback } = useResize({
    itemWidth: 520,
    defaultColSpan: 12,
  });

  const [hasTaptap, setHasTaptap] = useState(false);
  useEffect(() => {
    setHasTaptap(
      filter?.channel?.includes('taptap') || filter?.channel.length === 0,
    );
  }, [filter]);

  const {
    userScoreTrendsLoading: loading,
    userScoreTrendsApiError: apiErr,
    globalTrendsTimeline: mobileTrendsData,
  } = useGetStoreTimeline({
    keepParams: filter,
    channel: channel,
    splitRegion: false,
  });

  const ChartElements = useMemo(() => {
    let elements: Array<JSX.Element> = [];
    for (const key in mobileTrendsData) {
      const element = mobileTrendsData[key];
      if (!hasTaptap && key === 'taptap') {
        continue;
      }
      elements.push(
        <ScoreTrendBox
          gameInfo={gameInfo}
          scoreApiErr={apiErr}
          filterParams={filter}
          platformData={element}
          platform={key}
          key={key}
        />,
      );
    }

    return elements;
  }, [mobileTrendsData, gameInfo, hasTaptap, colSpan, formatMessage]);

  return (
    <CardCommon
      loading={loading}
      loadingHeight={350}
      className={`dbo-scoretrendbox ${showMoreScoreTrend ? 'show-all' : ''} ${
        hasTaptap ? 'dbo-scoretrendbox--3' : ''
      }`}
      title={formatMessage({ id: 'Score Trends' })}
    >
      <>
        <Row ref={refCallback} className="dbo-scoretrendbox-row">
          {ChartElements}
        </Row>
        {/* 存在第二行时才需要 */}
        {hasTaptap && (
          <div className="dbo-scoretrendbox-more" onClick={showMoreTrend}>
            {showMoreScoreTrend ? (
              <span>{formatMessage({ id: 'Show Less' })}</span>
            ) : (
              <>
                <span>{formatMessage({ id: 'Show' })}</span>
                <img src={TaptapLogo} />
              </>
            )}
          </div>
        )}
      </>
    </CardCommon>
  );
}
